import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment-timezone';
import get from 'lodash/get';
import './SearchResultRow.css';

const propTypes = {
  item: PropTypes.object,
};

class SearchResultRow extends Component {
  get title() {
    const item = this.props.item;
    switch (item.item_type) {
      case 'client':
        const name =
          item.person.company_name ||
          `${item.person.first_name} ${item.person.last_name}`;
        return (
          <div>
            Client
            <br />
            <strong>{name}</strong>
          </div>
        );
      case 'policy':
        return (
          <div>
            Policy #{item.policy_number || 'n/a'}
            <br />
            <strong>{item.vertical.name}</strong>
          </div>
        );
      default:
        return '';
    }
  }

  get contactInfo() {
    const person =
      this.props.item.person || get(this.props.item, 'client.person');
    return (
      <div>
        {person.email}
        <br />
        {person.phone_number}
      </div>
    );
  }

  get navUrl() {
    const item = this.props.item;
    switch (item.item_type) {
      case 'client':
        return `/dashboard/clients/${item.id}`;
      case 'policy':
        return `/dashboard/clients/${item.client.id}/policies/${item.id}`;
      default:
        return null;
    }
  }

  render() {
    const { item, className, onClick, ...otherProps } = this.props;
    return (
      <tr
        {...otherProps}
        className={classnames('SearchResultRow', className)}
        data-item-type={item.item_type}
        data-nav-url={this.navUrl}
        onClick={onClick}
      >
        <td className="SearchResultRow-title">
          <span className="fa-2x fa-stack fa-fw m-r-15">
            <i
              className="fas fa-circle fa-stack-2x"
              style={{ color: '#e6e6e6' }}
            />
            <i
              className={classnames('fa fa-stack-1x', {
                'fa-user': item.item_type === 'client',
                'fa-file-alt': item.item_type === 'policy',
              })}
              style={{ color: '#626262' }}
            />
          </span>
          {this.title}
        </td>
        <td className="v-align-middle">{this.contactInfo}</td>
        <td className="v-align-middle">
          {get(item, 'person.address.region.name') || 'n/a'}
        </td>
        <td className="v-align-middle">
          {moment(item.created_at).format('MMM DD, YYYY')}
        </td>
      </tr>
    );
  }
}

SearchResultRow.propTypes = propTypes;

export default SearchResultRow;
